export default "__VITE_ASSET__DqsZ7C27__"